export default __webpack_public_path__ + "static/media/Glasgow.494b0e25.jpg";